import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import isNil from 'lodash/isNil';
import PaymentDetailsStatus from './paymentDetailsStatus';
import Money from '../../../../common/money';

const PaymentDetails = ({ paymentDetailsData, dataForStatus }) => {
  const {
    serviceList,
    moreThanOneService,
    tip,
    total,
    totalPrice,
    totalTaxes,
    discounts,
    refundedAmount,
    isRefunded,
  } = paymentDetailsData;

  const displayRefund = isRefunded || refundedAmount > 0;

  const renderServices = serviceList => serviceList.map((service) => {
    const { key, name, cost, tax, total } = service;
    let status;
    if (dataForStatus) {
      status = (
        <PaymentDetailsStatus
          serviceId={service.serviceId}
          dataForStatus={dataForStatus}
        />
      );
    } else {
      status = (
        <div className="c-status c-status--red">Unpaid</div>
      );
    }

    const statusClass = classnames('c-table-card__cell u-1/7-large-and-up', {
      'u-color-grey-lighten-3': serviceList.length > 1,
    });

    return (
      <div className="c-table-card__row" key={key}>
        <div className="c-table-card__cell u-2/7-large-and-up">
          <div className="c-input" data-automation-id="text:serviceName">{name}</div>
        </div>
        <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-1/7-large-and-up">
          <div className="c-input" data-automation-id="text:serviceCost"><Money>{cost}</Money></div>
        </div>
        <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-1/7-large-and-up">
          <div className="c-input" data-automation-id="text:serviceTax"><Money>{tax}</Money></div>
        </div>
        <div display-if={!moreThanOneService} className="c-table-card__cell u-1/7-large-and-up">
          <div className="c-input" data-automation-id="text:serviceTip"><Money>{tip}</Money></div>
        </div>
        <div className="c-table-card__cell u-1/7-large-and-up">
          <div className="c-input" data-automation-id="text:serviceTotal"><Money>{total}</Money></div>
        </div>
        <div className="c-table-card__cell" display-if={!isNil(discounts)}>
          <div
            className={classnames('c-input', { 'u-font-color-red': discounts })}
            data-automation-id="text:serviceDiscount"
            display-if={!moreThanOneService}
          >
            <Money>{discounts}</Money>
          </div>
        </div>
        <div className="c-table-card__cell" display-if={displayRefund && !moreThanOneService}>
          <div className="c-input u-font-color-red">
            <Money>{refundedAmount}</Money>
          </div>
        </div>
        <div className={statusClass}>{status}</div>
      </div>
    );
  });

  if (!serviceList.length) {
    return null;
  }

  return (
    <div className="u-ph u-pt- u-mb-">
      <div className="c-label c-label--small-green u-mb--">Payment Details</div>
      <div className="c-table-card c-table-card--payment-details u-p--">
        <div className="c-table-card__head">
          <div className="c-table-card__cell c-label u-2/7-large-and-up">Service</div>
          <div
            className="c-table-card__cell c-label u-visible-table-cell-for-large-and-up u-1/7-large-and-up"
          >
            Price
          </div>
          <div className="c-table-card__cell c-label u-visible-table-cell-for-large-and-up u-1/7-large-and-up">Tax</div>
          <div className="c-table-card__cell c-label u-1/7-large-and-up" display-if={!moreThanOneService}>Tip</div>
          <div className="c-table-card__cell c-label u-1/7-large-and-up">Total</div>
          <div className="c-table-card__cell c-label u-1/7-large-and-up" display-if={!isNil(discounts)}>
            Discount/Promos
          </div>
          <div
            className="c-table-card__cell c-label u-1/7-large-and-up"
            display-if={!moreThanOneService && displayRefund}
          >
            Refunded
          </div>
          <div className="c-table-card__cell c-label u-1/7-large-and-up">Status</div>
        </div>
        { renderServices(serviceList) }
        <div className="c-table-card__row" display-if={moreThanOneService}>
          <div className="c-table-card__cell">
            <div className="c-input">Tip:</div>
          </div>
          <div className="c-table-card__cell u-visible-table-cell-for-large-and-up" />
          <div className="c-table-card__cell u-visible-table-cell-for-large-and-up" />
          <div className="c-table-card__cell">
            <div className="c-input"><Money>{tip}</Money></div>
          </div>
        </div>
        <div className="c-table-card__row" display-if={moreThanOneService}>
          <div className="c-table-card__cell">
            <div className="c-input">Total:</div>
          </div>
          <div className="c-table-card__cell u-visible-table-cell-for-large-and-up">
            <div display-if={moreThanOneService} className="c-input"><Money>{totalPrice}</Money></div>
          </div>
          <div className="c-table-card__cell u-visible-table-cell-for-large-and-up">
            <div display-if={moreThanOneService} className="c-input"><Money>{totalTaxes}</Money></div>
          </div>
          <div className="c-table-card__cell">
            <div className="c-input"><Money>{total}</Money></div>
          </div>
          <div className="c-table-card__cell" display-if={!isNil(discounts)}>
            <div className={classnames('c-input', { 'u-font-color-red': discounts })}><Money>{discounts}</Money></div>
          </div>
        </div>
        <div className="c-table-card__row" display-if={moreThanOneService}>
          <div className="c-table-card__cell" display-if={displayRefund}>
            <div className="c-input">Refunded:</div>
          </div>
          <div className="c-table-card__cell" display-if={displayRefund}>
            <div className="c-input u-font-color-red"><Money>{refundedAmount}</Money></div>
          </div>
        </div>
      </div>
    </div>
  );
};
PaymentDetails.propTypes = {
  paymentDetailsData: PropTypes.object.isRequired,
  dataForStatus: PropTypes.object,
};

export default PaymentDetails;
